import {IView} from '@gongxigames/framework/core/types/IView';

export interface ILoadingScreenView extends IView {
    start(): void;
    loadingComplete(hideImmediately: boolean): void;
    enableFirstInteraction(enable: boolean): void;
    updateProgress(progress: number): void;
}
